import angular from "angular";

angular
	.module('app')
	.component('notificationIndirectReplyForComment', {
		template: require('./notification-indirect-reply-for-comment.html'),
		controller: ['$http', controller],
		bindings: {
			resolve: '<',
			close: '&',
			dismiss: '&'
		}
    });
            
function controller($http) {
        
	let $ctrl = this;

	$ctrl.$onInit = function () {
		$ctrl.notify = $ctrl.resolve.notification;
    };
}